import { capitalize } from "@/mixins";
import { ResourceAPIResponse } from "@/typings/scheduler";

// The one rule for a technician's level label: installers read "Installer",
// everyone else their capitalised skill level, and no level gives "".
export function technicianLevelLabel(
  technician: Pick<ResourceAPIResponse, "installer" | "skill_level">
): string {
  if (technician.installer) return "Installer";
  return technician.skill_level ? capitalize(technician.skill_level) : "";
}
